module.exports = __webpack_public_path__ + "static/media/img.630930a8.svg";